// Suurten ruutujen valloitus Passissa: suuri ruutu (noin 1,2 km) antaa oman potin, kun kaikki sen
// 64 pikkuruutua on kerätty. Vesiruudut ja muut vaikeat kerätään vaivalla ja vuodenajan mukaan
// (jäällä kävellen, kesällä soutaen), joten mikään ruutu ei ole vaatimuksesta pois.
// Kortti näyttää lähimpänä valmista olevat ruudut ja vie ne kartalle.

import { tileBounds } from "../lib/geo.js";
import { largeTileProgress, progressText, splitProgress } from "../lib/bigTiles.js";

const SHOWN = 4; // kapealla näytöllä lyhyt lista: lähimpänä valmista olevat

export function BigTilesCard({ app }) {
  const tiles = app.tiles;
  if (!tiles?.small?.length) return null;
  const progress = largeTileProgress(tiles.small.map((t) => t.key), tiles.small_zoom, tiles.large_zoom);
  const { conquered, open } = splitProgress(progress);

  return (
    <section class="big-card" aria-label="Suurten ruutujen valloitus">
      <h2>Suurten ruutujen valloitus</h2>
      <p class="s">
        Kun kaikki ison ruudun 64 pikkuruutua on kerätty, ruutu on valloitettu ja saat siitä erikseen ison potin.
        Valloitettuja: <b>{conquered.length}</b>.
      </p>
      <ul class="big-list">
        {open.slice(0, SHOWN).map((p, i) => (
          <li key={p.key}>
            <div class="big-row">
              <span class="big-label"><span><b>Ruutu {i + 1}</b> {p.done}/{p.total}</span><small>{p.total - p.done} puuttuu</small></span>
              <button class="btn btn-quiet" onClick={() => app.showOnMap(tileBounds(p.key))} aria-label={`Ruutu ${i + 1}: ${progressText(p)}. Näytä kartalla`}>Kartalle</button>
            </div>
            <div class="bar" role="progressbar" aria-valuemin={0} aria-valuemax={p.total} aria-valuenow={p.done} aria-label={`Ruutu ${i + 1}: ${p.done}/${p.total} pikkuruutua`}>
              <i style={{ width: `${(p.done / p.total) * 100}%` }} />
            </div>
          </li>
        ))}
      </ul>
      {open.length > SHOWN && <p class="s">Ja {open.length - SHOWN} muuta aloitettua ruutua.</p>}
    </section>
  );
}
